import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'app/services/http.service';

@Component({
  selector: 'app-bundle-types',
  templateUrl: './bundleTypes.component.html',
  styleUrls: ['./bundleTypes.component.scss'],
})
export class BundleTypesComponent implements OnInit {

  saving = false;
  loading = true;
  bundleTypes: any;

  displayedColumns: any = [
    { key: 'name', label: 'Name', type: 'string' },
    { key: 'catalog', label: 'Catalog Item', type: 'boolean' },
    { key: 'percentageAvailable', label: 'Bundle Type Usage', type: 'progress' },
    { key: 'totalBundles', label: 'Total Bundles', type: 'string' },
    { key: 'availableBundles', label: 'Available Bundles', type: 'string' },
    { key: 'menu', label: 'Actions', type: 'menu' },
  ];

  permissions;

  constructor(private readonly _rotue: ActivatedRoute, private readonly _httpService: HttpService, private readonly _router: Router) { }

  ngOnInit() {
    this.load();
  }

  async load() {
    this.loading = true;

    this.bundleTypes = await this._httpService.get('inventory/bundleTypes');
    this.permissions = await this._httpService.get('people/authenticated/permissions');

    this.loading = false;
  }

  add() {
    this._router.navigateByUrl('/inventory/bundleTypes/0');
  }

  rowClick(id: any) {
    this._router.navigateByUrl('/inventory/bundleTypes/bundles/' + id);
  }

  edit(id: any) {
    this._router.navigateByUrl('/inventory/bundleTypes/' + id);
  }

  async delete(ids: []) {
    this.loading = true;
    const promises = [];
    for (let i = 0; i < ids.length; i++) {
      promises.push(this._httpService.delete(`inventory/bundleTypes/${ids[i]}`));
    }
    await Promise.all(promises);
    await this.load();
  }

}
